var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded && !_vm.maintenance)?_c('v-app',{staticClass:"page-wrapper",class:[
    _vm.isRoot ? 'is-root' : ''
  ],attrs:{"dark":""}},[_c('Header'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1),_c('Footer',{attrs:{"menu":_vm.footerMenu}})],1):(!_vm.loaded)?_c('div',{class:[
    'app-loading page-wrapper',
    _vm.fadeout ? 'fadeout' : ''
  ]},[_c('div',{staticClass:"loading-icon clipping-logo"})]):(_vm.maintenance && _vm.loaded)?_c('div',{staticClass:"site-maintenance"},[_c('img',{attrs:{"src":require("./assets/ashtree-logo.png"),"width":"400","height":"118"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }